import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { LoggerService } from './logger.service';

function serializeReason(reason: unknown): Record<string, unknown> {
  if (reason instanceof Error) return { name: reason.name, message: reason.message, stack: reason.stack };
  if (typeof reason === 'object' && reason !== null) {
    try { return { value: JSON.parse(JSON.stringify(reason)) }; }
    catch { return { value: String(reason) }; }
  }
  return { value: String(reason) };
}

@Injectable()
export class LoggerErrorHandler implements ErrorHandler {
  private installed = false;

  constructor(private logger: LoggerService, private zone: NgZone) {
    this.installWindowHandlers();
  }

  handleError(error: any): void {
    this.logger.error('app.angular.error', serializeReason(error));
    console.error(error);
  }

  private installWindowHandlers(): void {
    if (this.installed || typeof window === 'undefined') return;
    this.installed = true;

    window.addEventListener('error', (ev: ErrorEvent) => {
      this.zone.run(() => {
        this.logger.error('app.window.error', {
          message: ev.message,
          source: ev.filename,
          line: ev.lineno,
          col: ev.colno,
          stack: ev.error instanceof Error ? ev.error.stack : undefined,
        });
      });
    });

    window.addEventListener('unhandledrejection', (ev: PromiseRejectionEvent) => {
      this.zone.run(() => {
        this.logger.error('app.unhandled.rejection', serializeReason(ev.reason));
      });
    });
  }
}
